import { render, staticRenderFns } from "./SidebarNav.vue?vue&type=template&id=0a801256&scoped=true&"
import script from "./SidebarNav.vue?vue&type=script&lang=js&"
export * from "./SidebarNav.vue?vue&type=script&lang=js&"
import style0 from "./SidebarNav.vue?vue&type=style&index=0&id=0a801256&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a801256",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a801256')) {
      api.createRecord('0a801256', component.options)
    } else {
      api.reload('0a801256', component.options)
    }
    module.hot.accept("./SidebarNav.vue?vue&type=template&id=0a801256&scoped=true&", function () {
      api.rerender('0a801256', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forks/SidebarNav.vue"
export default component.exports